<template>
  <div class="container mx-auto">
    <CRow class="d-flex justify-content-center">
      <CCol sm="10" md="10" lg="10" xl="10">
        <CCard>
          <CCardHeader class="d-flex justify-content-between responsive">
            <span><i class="fas fa-coins"></i>&nbsp;Producto</span>
            <div class="d-flex flex-wrap">
              <button
                @click="returnHome"
                type="button"
                class="btn btn-sm text-white mr-2"
                style="background: #e46666"
              >
                <i class="fas fa-hand-point-left"></i> Retroceder
              </button>
              <button
                type="button"
                class="btn btn-sm text-white"
                style="background: #39f"
                @click="mtd_action"
              >
                <i class="fas fa-dollar-sign"></i>
                <b>Guardar</b>
              </button>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="12" md="6" lg="6">
                <cSelectForm
                  label="Almacen de salida"
                  placeholder="Seleccione almacen"
                  :options="data_almacenes"
                  :value.sync="selectedAlmacenSalida"
                />
              </CCol>
              <CCol xs="12" sm="12" md="6" lg="6">
                <cSelectForm
                  label="Almacen de destino"
                  placeholder="Seleccione almacen"
                  :options="filteredAlmacenes"
                  :value.sync="selectedAlmacen"
                />
              </CCol>
              <CCol xs="12" sm="12" md="6" lg="6">
                <CInput
                  label="Código de Producto"
                  placeholder="Digite de barras mediante la lectora"
                  v-model="searchBarcode"
                  @keypress.enter="filterProductoBarcode"
                />
              </CCol>
              <CCol xs="12" sm="12" md="6" lg="6">
                <CInput
                  label="Buscar Producto"
                  type="search"
                  v-model="searchQuery"
                  @keypress.enter="filterProducts"
                  placeholder="Digite nombre de producto.."
                />
              </CCol>
              <CCol xs="12" sm="12" md="12" lg="12">
                <CTextarea
                  label="Motivo"
                  placeholder="Ingrese el motivo..."
                  rows="3"
                  v-model="motive"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardHeader class="d-flex justify-content-start">
            <span><i class="fa fa-store"></i>&nbsp; Detalle de venta </span>
          </CCardHeader>
          <CCardBody>
            <div class="table-responsive">
              <table
                id="dataTableLists"
                class="table table-sm table-hover table-bordered dt-responsive nowrap"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th width="60">N°</th>
                    <th>Producto</th>
                    <th>Unidad</th>
                    <th>Stock</th>
                    <th>Precio</th>
                    <th>Cantidad</th>
                    <th>Subtotal</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(product, index) in productList"
                    :key="index"
                    @click="openProductModal(product)"
                    style="cursor: pointer"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ product.product.name }}</td>
                    <td>{{ product.unit.name }}</td>
                    <td>
                      {{
                        product.stock ? parseInt(product.stock) : product.stock
                      }}
                    </td>
                    <td>{{ product.price }}</td>
                    <td>{{ product.quantity }}</td>
                    <td>{{ (product.price * product.quantity).toFixed(2) }}</td>
                    <td>
                      <button
                        @click.stop="removeProduct(index)"
                        class="btn btn-danger btn-sm"
                      >
                        <i class="fas fa-trash"></i> Eliminar
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <div class="container mx-auto p-4">
      <cModalUpdateSale
        :title="modalUpdateSale.title"
        :boo_modal="modalUpdateSale.modal_form"
        :product="modalUpdateSale.product"
        @closeModalUpdateSale="closeModalUpdateSale"
        @updateProduct="handleUpdateProduct"
      />

      <cModalProductList
        :products="filteredProducts"
        :boo_modal="modalProductList.modal_form"
        @close="closeProductListModal"
        @selectProduct="selectProduct"
      />
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import cSelectForm from "../../../../shared/inputs/cSelect.vue";
import cModalUpdateSale from "../modals/cModalUpdateSale.vue";
import cModalProductList from "../modals/cModalProductList.vue";
export default {
  name: "movementstock",
  components: {
    cSelectForm,
    cModalUpdateSale,
    cModalProductList,
  },
  data() {
    return {
      prefix: "stock_transfer",
      data_almacenes: [],
      data_product: [],
      estado: true,
      searchQuery: "", // Para almacenar lo que escribe el usuario
      searchBarcode: "", // Para almacenar lo que escribe el usuario
      filteredProducts: [], // Para almacenar los productos filtrados
      filteredProductsBarcode: [], // Para almacenar los productos filtrados
      productList: [],
      selectedAlmacen: "",
      selectedAlmacenSalida: "",
      motive: "",
      newProduct: {
        product: {
          id: "",
          name: "",
        },
        price: "",
        quantity: 1,
        subtotal: 0,
        stock: 0,
      },
      modalUpdateSale: {
        title: "Editar",
        modal_form: false,
        product: {
          product: {
            id: "",
            name: "",
          },
          price: "",
          quantity: "",
          subtotal: "",
        },
      },
      modalProductList: {
        modal_form: false,
      },
    };
  },
  computed: {
    filteredAlmacenes() {
      if (!this.selectedAlmacenSalida) {
        return this.data_almacenes; // Si no hay almacén de salida seleccionado, mostrar todos
      }

      // Filtrar para eliminar el almacén ya seleccionado como origen
      return this.data_almacenes.filter(almacen => almacen.value != this.selectedAlmacenSalida);
    }
  },
  watch: {
    selectedAlmacenSalida(newValue) {
      if (newValue && newValue == this.selectedAlmacenSalida) {
        // this.selectedAlmacen = "";
        this.showProduct(newValue); // Resetear el almacén de destino si coincide con el nuevo valor del almacén de salida
      }
    },
    // selectedAlmacen(newAlmacen) {
    //   if (newAlmacen) {
    //     // this.showProduct(newAlmacen);
    //   }
    // },
  },
  created() {
    this.showAlmacenes();
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome() {
      this.$emit("returnHome");
    },
    showProduct(almacenId) {
      this.data_product = []; // Clear previous products
      this.get({
        url:
          this.$store.getters.get__url +
          "/stock_transfer/byProductalmacen/" +
          this.$store.getters.get_campu.id +
          "/" +
          almacenId,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.data.data && response.data.data.length > 0) {
            response.data.data.forEach((arr) => {
              const { stock, product_unit } = arr;
              this.data_product.push({
                label: product_unit.product.name,
                value: product_unit.product.id,
                price: product_unit.product.price[0].sale_price,
                value_unit: product_unit.unit.id,
                label_unit: product_unit.unit.name,
                barcodes: product_unit.product.barcode,
                stock: stock,
                stock_id: arr.id,
                product_unit_id: arr.product_unit_id
              });
            });
          }
        })
        .catch((error) => {
          console.error("Error loading products:", error);
        });
    },
    showAlmacenes() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/stock_transfer/showAlmacenes/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.forEach((element) => {
            this.data_almacenes.push({
              label: element.name,
              value: element.id,
            });
          });
        })
        .catch((errors) => {});
    },
    filterProducts() {
      if (this.searchQuery) {
        this.filteredProducts = this.data_product.filter((product) =>
          product.label.toLowerCase().includes(this.searchQuery.toLowerCase())
        );

        if (this.filteredProducts.length > 0) {
          this.modalProductList.modal_form = true;
        }
      }
    },
    selectProduct(product) {
      console.log(product);
      
      this.searchQuery = "";
      const existingProduct = this.productList.find(
        (p) =>
          p.product.id === product.value && p.unit.id === product.value_unit
      );

      if (existingProduct) {
        // If the product exists, increment its quantity
        if (existingProduct.quantity < product.stock) {
          existingProduct.quantity += 1;
        } else {
          Swal.fire({
            title: "La cantidad excede del stock disponible",
            icon: "warning",
          });
        }
      } else {
        // If the product doesn't exist, add it to the list
        const newProduct = {
          product: {
            id: product.value,
            name: product.label,
          },
          unit: {
            id: product.value_unit,
            name: product.label_unit,
          },
          price: product.price,
          quantity: 1,
          subtotal: product.price,
          stock: product.stock,
          stock_id: product.stock_id,
          product_unit_id: product.product_unit_id

        };
        this.productList.push(newProduct);
      }

      // Close the modal after selection
      this.closeProductListModal();
    },
    closeProductListModal() {
      this.modalProductList.modal_form = false;
    },
    removeProduct(index) {
      Swal.fire({
        title: "¿Desea eliminar el producto?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          // Si el usuario confirma, se elimina el producto
          this.productList.splice(index, 1);
          Swal.fire("Eliminado!", "El producto ha sido eliminado.", "success");
        }
      });
    },

    // Existing methods
    clear() {
      this.productList = [];
      this.data_product = [];
      this.selectedAlmacen = "";
      this.motive = "";
    },
    openProductModal(product) {
      this.modalUpdateSale = {
        title: "Editar",
        modal_form: true,
        product: product,
      };
    },
    closeModalUpdateSale() {
      this.modalUpdateSale = {
        modal_form: false,
      };
    },
    handleUpdateProduct(updatedProduct) {
      const index = this.productList.findIndex(
        (p) => p.product.id === updatedProduct.product.id
      );
      if (index !== -1) {
        this.$set(this.productList, index, updatedProduct);
      }
    },
    filterProductoBarcode() {
      if (this.searchBarcode) {
        this.filteredProductsBarcode = this.data_product.filter((product) =>
          product.barcodes.some(
            (barcode) => barcode.name === this.searchBarcode
          )
        );

        if (this.filteredProductsBarcode.length > 0) {
          this.addProductoBarcode(this.filteredProductsBarcode);
        } else {
          Swal.fire({
            title: "Código de barra no encontrada",
            icon: "warning",
          });
        }
      }
    },
    addProductoBarcode(product) {
      const prod = product[0];
      const existingProduct = this.productList.find(
        (p) => p.product.id === prod.value && p.unit.id === prod.value_unit
      );

      if (existingProduct) {
        if (existingProduct.quantity < prod.stock) {
          existingProduct.quantity += 1;
        } else {
          Swal.fire({
            title: "La cantidad excede del stock disponible",
            icon: "warning",
          });
        }
      } else {
        const newProduct = {
          product: {
            id: prod.value,
            name: prod.label,
          },
          unit: {
            id: prod.value_unit,
            name: prod.label_unit,
          },
          price: prod.price,
          quantity: 1,
          subtotal: prod.price,
          stock: prod.stock,
        };
        this.productList.push(newProduct);
      }
    },
    mtd_action() {
      if (!this.selectedAlmacen) {
        Swal.fire({
          title: "Debe seleccionar un almacén de destino",
          icon: "warning",
        });
        return;
      }
      if (this.productList.length == 0) {
        Swal.fire({
          title: "Debe agregar al menos un producto a la lista",
          icon: "warning",
        });
        return;
      }
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/store",
        token: this.$store.getters.get__token,
        params: {
          productos: this.productList,
          old_almacen: this.selectedAlmacenSalida,
          new_almacen: this.selectedAlmacen,
          campu_id: this.$store.getters.get_campu.id,
          motive: this.motive,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            Swal.fire({
              title: "Movimiento exitoso",
              icon: "success",
            });
            this.clear();
            // this.selectedAlmacenStock = this.$store.getters.get_campu.id;
            // this.showProduct(this.selectedAlmacenStock);
          } else {
            Swal.fire({
              title: "Ocurrio un error",
              icon: "danger",
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
  },
};
</script>

<style scoped>
.bg-purple {
  background-color: #926cdc;
}

.font-bold {
  font-weight: bold;
}

.container-card-body {
  background-color: #dee2e6;
  border-radius: 8px;
  cursor: pointer;
}

.lista {
  background-color: #ebedef;
  border-radius: 6px;
  width: 100%;
  list-style-type: none;
  margin: 0;
  padding: 0;
  margin-top: -10px;
}

.lista li {
  width: 100%;
  padding: 2px 0 2px 10px;
}

.lista li:hover {
  border-radius: 6px;
  background-color: #39f;
  list-style-type: none;
  color: #fff;
}

.table-responsive {
  overflow-x: auto;
}

.responsive {
  flex-direction: row;
}
</style>